import React, { useEffect, useState } from "react";
import Fotter from "./Fotter";
import Navbar from "./Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import { BASE_URL } from "../Pages/Config";
import { formatDistanceToNow } from "date-fns";
import axios from "axios";
import "./answer.css";

import { toast } from "react-toastify";

export default function SettingQuesAnswer() {
  const [questions, setQuestions] = useState([]);
  // Store answers keyed by question_id
  const [answers, setAnswers] = useState({});
  const { id } = useParams();
  const [userId, setUserId] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setToastMessage] = useState("");
  const [visibleInputs, setVisibleInputs] = useState({});

  const fetchQuestions = async () => {
    try {
      const storedUserId = Cookies.get("user_id");
      setUserId(storedUserId);

      // Fetch questions for the given id (passed as param)
      const res = await fetch(
        `${BASE_URL}/get_question.php?type=by_id&user_id=${id}&t=${Date.now()}`,
        { cache: "no-store" }
      );

      // Optional: check response status
      if (!res.ok) {
        console.error("Network response was not ok", res.statusText);
        return;
      }

      // Read response text and parse JSON
      const text = await res.text();

      // Sometimes API returns invalid JSON, wrap parse in try-catch
      let data;
      try {
        data = JSON.parse(text);
      } catch (parseErr) {
        console.error("Failed to parse JSON:", parseErr, text);
        return;
      }

      if (data.success) {
        setQuestions(data.data);
      } else {
        console.error("API error:", data.message);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    if (id) {
      fetchQuestions();
    }
  }, [id]);

  // Toggle textarea visibility per question_id
  const toggleAnswerBox = (questionId: string) => {
    setVisibleInputs((prev) => ({ ...prev, [questionId]: !prev[questionId] }));
  };

  // Update answer text per question_id
  const handleAnswerChange = (questionId: string, value: string) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  // Submit answer for a specific question
  const questionsubmit = async (e: React.FormEvent, question_id: string) => {
    e.preventDefault();

    const formData = {
      question: answers[question_id] || "",
      question_id: id,
    };
    setShowLoading(true);

    console.log("Submitting answer:", formData);

    try {
      const res = await axios.post(`${BASE_URL}/submit_answer.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });
      console.log(res);

      const data = res.data;

      if (data.success) {
        setToastMessage("Answer submitted successfully!");
        setAnswers((prev) => ({ ...prev, [question_id]: "" }));
        // Optionally hide the textarea after submission
        setVisibleInputs((prev) => ({ ...prev, [question_id]: false }));

        fetchQuestions();
      } else {
        setShowLoading(false);
        setToastMessage(data.message || "Submission failed");
      }
    } catch (err) {
      setShowLoading(false);
      console.error(err);
      setToastMessage("Something went wrong");
    }

    setTimeout(() => setToastMessage(""), 5000);
  };

  // console.log(questions);

  const [formData, setFormData] = useState({
    id: id,
    type: questions.type, // "1" or "0"
  });

  const [updateLoader, setUpdateLoader] = useState(false);

  const updateFormData = async () => {
    try {
      setUpdateLoader(true);

      console.log("question id : ", id);
      const response = await axios.post(
        `${BASE_URL}/submit_answer.php?type=checkbox`,
        {
          id: id,
        }
      );

      console.log("Server response:", response.data);

      if (response.data.success) {
        toast.success("Updated successfully!");
        fetchQuestions(); // 🔄 Refresh data only if update succeeded
      } else {
        toast.error(response.data.message || "Update failed!");
      }
    } catch (error) {
      console.error("Error updating:", error);
      toast.error("Something went wrong while updating!");
    } finally {
      setUpdateLoader(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>
                <p>Question & Answers</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-sm-12 col-md-8 col-lg-9 col-xl-9">
              <div className="setting-info">
                <div className="col-12" style={{ padding: "10px" }}>
                  {questions.length === 0 && <p>No questions found.</p>}

                  {questions.map((q) => (
                    <div
                      key={q.question_id}
                      className="k"
                      style={{ marginBottom: "30px" }}
                    >
                      <div className="notification">
                        <div
                          className="notification-mass"
                          style={{ width: "100%", padding: "10px" }}
                        >
                          <div className="notification-title">
                            <b>Question</b>
                            <p>
                              {formatDistanceToNow(
                                new Date(q.question_date + "Z"),
                                {
                                  addSuffix: true,
                                }
                              ).replace("about ", "")}
                            </p>
                          </div>
                          <div className="" style={{ marginLeft: "10px" }}>
                            <p>{q.question}</p>
                          </div>
                        </div>
                      </div>

                      {q.answer ? (
                        <div className="notification">
                          <div
                            className="notification-mass"
                            style={{ width: "100%", padding: "10px" }}
                          >
                            <div className="notification-title">
                              <b>Reply</b>
                              <p>
                                {formatDistanceToNow(
                                  new Date(q.question_date + "Z"),
                                  {
                                    addSuffix: true,
                                  }
                                ).replace("about ", "")}
                              </p>
                            </div>
                            <div className="">
                              <p>{q.answer}</p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div
                        className="askquestion"
                        style={{ marginTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <button
                            onClick={() => toggleAnswerBox(q.question_id)}
                          >
                            {visibleInputs[q.question_id]
                              ? "Cancel"
                              : "Give Answer"}
                          </button>

                          <p
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            Make Public{" "}
                            <input
                              type="checkbox"
                              checked={q.type == "1"}
                              onChange={updateFormData} // ✅ no need to pass e.target.checked anymore
                              // disabled={updateLoader}
                            />
                            {updateLoader && (
                              <span className="make-public-spinner"></span>
                            )}
                          </p>
                        </div>

                        {visibleInputs[q.question_id] && (
                          <form
                            onSubmit={(e) => questionsubmit(e, q.question_id)}
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            <textarea
                              placeholder="Type your answer here..."
                              cols={30}
                              rows={5}
                              value={answers[q.question_id] || ""}
                              onChange={(e) =>
                                handleAnswerChange(
                                  q.question_id,
                                  e.target.value
                                )
                              }
                              required
                              style={{ width: "100%", padding: "10px" }}
                            />

                            <input
                              type="submit"
                              className="submit"
                              value="Submit Answer"
                            />
                          </form>
                        )}

                        {showToast && (
                          <p style={{ color: "green", marginTop: "10px" }}>
                            {showToast}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}
      <Fotter />
    </>
  );
}
